import axios from "~/plugins/axios";

export default {
  getFactorByCredentials(username, password, rememberUsername) {
    return axios.post("/auth/login/factor", {
      username,
      password,
      remember_me: rememberUsername,
    }).then((response) => response.data);
  },
  sendEmailCode(username, password) {
    return axios.post("/auth/login/mail", {
      username,
      password,
    }).then((response) => response.data);
  },
  login(username, password, factor = null, otp = null) {
    const data = {
      username,
      password,
    };

    if (factor !== null) {
      data.login_method = factor;
    }

    if (factor === "yubi") {
      data.otp = otp;
    } else if (factor === "sms") {
      data.code = otp;
    } else if (factor === "email") {
      data.email_code = otp;
    }

    return axios.post("/auth/login", data).then((response) => response.data);
  },
  requestPasswordReset(username) {
    const data = {
      username,
    };

    return axios.post("/auth/reset", data).then((response) => response.data);
  },
  requestUsernameReminder(email) {
    const data = {
      email,
    };

    return axios.post("/auth/username", data).then((response) => response.data);
  },
  resetPassword(token, newPassword) {
    const data = {
      password: newPassword,
    };

    return axios.post(`/auth/reset/${token}`, data).then((response) => response.data);
  },
};
